export default __webpack_public_path__ + "static/backgroundDark-1998ddc00845f1083112756e82ed115c.webp";